import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map, take } from 'rxjs';

import { Chat } from '../models/chat.models';
import { getKakaoTalk } from '../store/chat.selectors';

import { getPage } from '@core/infrastructure/state/core.selectors';

@Component({
    selector: 'kakao',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './kakao.component.html',
})
export class KakaoComponent implements OnInit, AfterViewInit {
    @ViewChild('kakaoForm') public kakaoForm: ElementRef;

    public kakao$: Observable<Chat>;

    public isPage$ = this.store.select(getPage).pipe(map((page: any) => page === 'ItxChatPage'));

    public target$ = this.isPage$.pipe(map(isPage => isPage ? '_self' : '_blank'));

    constructor(private readonly store: Store) {}

    public ngOnInit(): void {
        this.kakao$ = this.store.select(getKakaoTalk);
    }

    public ngAfterViewInit(): void {
        this.isPage$
            .pipe(take(1))
            .subscribe((isPage) => {
                if (isPage) {
                    this.kakaoForm.nativeElement.submit();
                }
            });
    }
}
